import axios from "axios";
import Config from "config";

const pay = ({
  cardNumber,
  product,
  name,
  email,
  address,
  expirationMonth,
  expirationYear,
  CVV,
}) => {
  return new Promise((resolve, reject) => {
    fetch("https://direct.paylane.com/rest.js/cards/generateToken", {
      method: "POST",
      body: JSON.stringify({
        public_api_key: "f6a03667c51d2b6cc7ced39196c77847502c660b",
        card_number: cardNumber,
        expiration_month: expirationMonth,
        expiration_year: expirationYear,
        card_code: CVV,
        name_on_card: name,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        axios
          .post(`${Config.baseURL}/pay`, {
            token: res.token,
            email,
            address,
            product,
          })
          .then((res) => res.data)
          .then((loginResponse) => resolve(loginResponse))
          .catch((error) => console.log(error));
      });
  });
};

export default { pay };
